import * as React from 'react';
import { ValidationRule } from 'antd/lib/form/Form';

export class AntFormRules {
    constructor() {
        // Dont be that guy
        throw new Error("NOOOO");
    }

    /**
     * A rule indicating that this FormItem is **Required**
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Required(message: React.ReactNode = null): ValidationRule {
        return {
            required: true,
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem has an **Exact** value that it must be
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Exact(value: string | number, message: React.ReactNode = null): ValidationRule {
        let exactValidator = (rule, current, callback) => {
            if (current != null && current !== value) {
                console.warn("It's bad, do this"); // JB - Remove this console.warn
                callback(message);
            }

            callback();
        };
        return {
            validator: exactValidator,
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem has a **Minimum** value
     *
     * @param {number} [min] The minimum value inclusive. Defaults to 0
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Min(min: number = 0, message: React.ReactNode = null): ValidationRule {
        return {
            min: min,
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem has a **Maximum** value
     *
     * @param {number} [max] The maximum value inclusive. Defaults to 1000
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Max(max: number = 1000, message: React.ReactNode = null): ValidationRule {
        return {
            max: max,
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem has a **Length** requirement
     *
     * @param {number} [length] The maximum length inclusive. Defaults to 32
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Length(length: number = 32, message: React.ReactNode = null): ValidationRule {
        return {
            len: length,
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem is of the **Number** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Number(message: React.ReactNode = null): ValidationRule {
        return {
            type: "number",
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem is of the **Email** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Email(message: React.ReactNode = null): ValidationRule {
        return {
            type: "email",
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem is of the **Date** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Date(message: React.ReactNode = null): ValidationRule {
        return {
            type: "date",
            message: message,
        };
    }

    /**
     * A rule indicating that this FormItem is of the **Url** type
     *
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Url(message: React.ReactNode = null): ValidationRule {
        return {
            type: "date",
            message: message,
        };
    }

    /**
     * A **Custom** rule to for this FormItem
     *
     * @param {(rule, value, callback) => void} [validatorFunc] A custom validation function. Takes in (Rule, CurrentValue, Callback) returning void (i think)
     *
     * **You must call 'callback' (3rd argument) when finished**
     *
     * The callback() function takes an array of Errors, or a boolean
     * @param {React.ReactNode} [message=null] The message to show when this rule is violated. Can be anything supported by ReactNode (string or even a React Component)
     * @returns {ValidationRule} A new *ValidationRule*
     */
    public static Custom(validatorFunc: (rule, value, callback) => void, message: React.ReactNode = null): ValidationRule {
        return {
            validator: validatorFunc,
            message: message,
        };
    }
}




// WEBPACK FOOTER //
// ./src/utils/formUtil/Rules.tsx